'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOfferingsEnabled = exports.APPCENTER_ENABLED_CHECK_FAILED = exports.APPCENTER_ENABLED_CHECK_PASSED = exports.USER_PROFILE_FETCH_FAILED = exports.USER_PROFILE_FETCHED = exports.USER_PROFILE_FETCHING = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.fetchUserProfileIfNeeded = fetchUserProfileIfNeeded;
exports.isAppCenterEnabledCheck = isAppCenterEnabledCheck;
exports.default = userProfile;

var _merge2 = require('lodash/merge');

var _merge3 = _interopRequireDefault(_merge2);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var USER_PROFILE_FETCHING = exports.USER_PROFILE_FETCHING = '@@userProfileModule/USER_PROFILE_FETCHING';
var USER_PROFILE_FETCHED = exports.USER_PROFILE_FETCHED = '@@userProfileModule/USER_PROFILE_FETCHED';
var USER_PROFILE_FETCH_FAILED = exports.USER_PROFILE_FETCH_FAILED = '@@userProfileModule/USER_PROFILE_FETCH_FAILED';
var APPCENTER_ENABLED_CHECK_PASSED = exports.APPCENTER_ENABLED_CHECK_PASSED = '@@userProfileModule/IS_APPCENTER_ENABLED_CHECK_PASSED';
var APPCENTER_ENABLED_CHECK_FAILED = exports.APPCENTER_ENABLED_CHECK_FAILED = '@@userProfileModule/IS_APPCENTER_ENABLED_CHECK_FAILED';

var APIEndpoint = void 0;
var CTEEndpoint = _config2.default.CTEUrl;
if ((0, _utils.canUseDOM)()) {
  APIEndpoint = _config2.default.appcenterAPIBase.client + '/api/userprofile';
} else {
  APIEndpoint = _config2.default.appcenterAPIBase.server + '/api/userprofile';
}

var getOfferingsEnabled = exports.getOfferingsEnabled = function getOfferingsEnabled(profile) {

  var offeringsEnabled = [];

  if (profile.IsTripLinkUser) {
    offeringsEnabled.push('TRIPLINK');
  }

  if (profile.IsTravelUser) {
    offeringsEnabled.push('TRVSTD', 'TRVPRO');
  }

  if (profile.IsTravelUser && (profile.TravelOffering === 'PROFESSIONAL' || profile.TravelOffering === 'STANDARD')) {
    offeringsEnabled.push('TRQPRO');
  }

  if (profile.IsExpenseUser && (profile.ExpenseOffering === 'CTE' || profile.ExpenseOffering === 'HONG_KONG')) {
    offeringsEnabled.push('EXPSTD', 'INVSTD', 'INVPRO');
  }

  if (profile.IsExpenseUser && profile.ExpenseOffering === 'CTE') {
    offeringsEnabled.push('EXPPRO');
  }

  return offeringsEnabled;
};

function fetchUserProfileIfNeeded() {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getState, _getState$JWT, _getState$JWT$token, token, userProfile, options, url, response, user, offeringsEnabled;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getState = getState(), _getState$JWT = _getState.JWT;
              _getState$JWT = _getState$JWT === undefined ? {} : _getState$JWT;
              _getState$JWT$token = _getState$JWT.token, token = _getState$JWT$token === undefined ? '' : _getState$JWT$token, userProfile = _getState.userProfile;

              if (!(token && userProfile && !userProfile.offeringsEnabled)) {
                _context.next = 24;
                break;
              }

              options = {
                method: 'GET',
                headers: {
                  Authorization: 'Bearer ' + token
                }
              };
              url = '' + APIEndpoint;
              _context.prev = 6;
              _context.next = 9;
              return fetch(url, options);

            case 9:
              response = _context.sent;
              _context.next = 12;
              return response.json();

            case 12:
              user = _context.sent;

              if (getState().userProfile.offeringsEnabled) {
                _context.next = 17;
                break;
              }

              dispatch({ type: USER_PROFILE_FETCHING });

              offeringsEnabled = getOfferingsEnabled(user);
              return _context.abrupt('return', Promise.resolve(dispatch({
                type: USER_PROFILE_FETCHED,
                offeringsEnabled: offeringsEnabled,
                user: user
              })));

            case 17:
              _context.next = 22;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context['catch'](6);

              dispatch({ type: USER_PROFILE_FETCH_FAILED, error: _context.t0 });

            case 22:
              _context.next = 25;
              break;

            case 24:
              return _context.abrupt('return', Promise.resolve());

            case 25:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[6, 19]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

function isAppCenterEnabledCheck() {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var _getState2, profile;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dispatch(fetchUserProfileIfNeeded());

            case 2:
              _getState2 = getState(), profile = _getState2.userProfile.profile;


              if (profile && !profile.IsAppCenterEnabled) {
                dispatch({ type: APPCENTER_ENABLED_CHECK_FAILED });
                window.location = CTEEndpoint + '/errors/securitybreach.asp?nolog=1';
              } else {
                dispatch({ type: APPCENTER_ENABLED_CHECK_PASSED });
              }

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
}

var initialState = {};

function userProfile() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case USER_PROFILE_FETCHED:
      return _extends({}, state, {
        offeringsEnabled: action.offeringsEnabled,
        profile: action.user
      });
    case USER_PROFILE_FETCH_FAILED:
      return _extends({}, state, {
        error: action.error
      });
    case 'dev/user':
      return (0, _merge3.default)({}, state, action.newValue);
    default:
      return state;
  }
}


//////////////////
// WEBPACK FOOTER
// ./lib/userProfile/userProfileModule.js
// module id = 90
// module chunks = 0